import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "../../../common/consts/colors";

const CalendarsIcon = ({ color = "offWhite" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M4.5 9V19C4.5 20.1046 5.39543 21 6.5 21H18.5C19.6046 21 20.5 20.1046 20.5 19V9M4.5 9V7C4.5 5.89543 5.39543 5 6.5 5H8.5M4.5 9H20.5M20.5 9V7C20.5 5.89543 19.6046 5 18.5 5H16.5M16.5 5V3M16.5 5H8.5M8.5 5V3M12.5 13H12.51M8.5 13H8.51M16.5 13H16.51M12.5 17H12.51M8.5 17H8.51"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendarsIcon;
